// Migration 228's family rules. These are presentation gates, never a substitute
// for server ownership/role checks. No daily-report age rule applies here.
export type OwnerReportActor = {profileId: string; role: string};
export const OWNER_REPORT_ROLES = ['admin', 'management', 'farm_team', 'light', 'equipment_tech'] as const;

export function canReadOwnEquipmentReports(actor: OwnerReportActor | null | undefined): actor is OwnerReportActor {
  return !!actor?.profileId && (OWNER_REPORT_ROLES as readonly string[]).includes(actor.role);
}

export function canEditOwnerFueling(actor: OwnerReportActor | null | undefined, ownerId: string | null | undefined) {
  return canReadOwnEquipmentReports(actor) && (actor.role !== 'light' || ownerId === actor.profileId);
}

export function canDeleteOwnerFueling(actor: OwnerReportActor | null | undefined, ownerId: string | null | undefined) {
  return canEditOwnerFueling(actor, ownerId) && actor?.role !== 'equipment_tech';
}

export function canEditOwnerFuelSupply(actor: OwnerReportActor | null | undefined, ownerId: string | null | undefined) {
  return canReadOwnEquipmentReports(actor) && (actor.role === 'admin' || ownerId === actor.profileId);
}

export function canDeleteOwnCattleLog(actor: OwnerReportActor | null | undefined, authorId: string | null | undefined) {
  if (!actor?.profileId) return false;
  return (
    ['admin', 'management'].includes(actor.role) ||
    (['light', 'farm_team'].includes(actor.role) && authorId === actor.profileId)
  );
}

export function canRestoreOwnerReport(actor: OwnerReportActor | null | undefined) {
  return !!actor?.profileId && actor.role === 'admin';
}
